import { BID_TEMPLATE_ID, FDMCA_TEMPLATE_ID } from "../sections.js";
import { formIsBid, formIsCompleted, formIsFdmca, formIsMca, formIsVoid, getLatestVersion, } from "../types/form.js";
// Names the assessment itself rather than any form within it, for the audit
// trail and for an assessment whose forms have all been deleted.
export const MCA_ASSESSMENT_NAME = "MCA Forms";
// Forms that still count towards the assessment. A deleted form leaves the
// assessment (its slot may be refilled); a voided one has been superseded.
export function liveMcaForms(forms) {
    return forms.filter((form) => formIsMca(form) && form.status !== "deleted" && !formIsVoid(form));
}
function mcaFormsPresent(forms) {
    const live = liveMcaForms(forms);
    return {
        fdmca: live.some(formIsFdmca),
        bid: live.some(formIsBid),
    };
}
/**
 * The title shown for an MCA assessment wherever a form context is listed
 * (caseload, patient timeline, work item). A context holding both forms is
 * named for the combined assessment; one holding a single form is named for
 * that form.
 */
export function mcaFormContextTitle(forms) {
    const { fdmca, bid } = mcaFormsPresent(forms);
    if (fdmca && bid)
        return "MCA Forms - FDMCA and BID";
    if (fdmca)
        return "Functional and Diagnostic Mental Capacity Assessment";
    if (bid)
        return "Best Interest Decision";
    return MCA_ASSESSMENT_NAME;
}
// The FDMCA records capacity as a conclusion on its own scale, not a yes/no.
export function fdmcaFoundLackOfCapacity(form) {
    if (!form || !formIsFdmca(form))
        return false;
    const partOne = getLatestVersion(form).data[0]?.data;
    return partOne?.lackOfCapacity === "lacks-capacity";
}
/**
 * Which linked MCA form the user should be invited to start next, given
 * everything already in the assessment. Returns null when no invitation is
 * warranted — the partner form already exists, nothing is complete yet, or the
 * FDMCA concluded the person has capacity (in which case a Best Interest
 * Decision does not follow from it).
 */
export function mcaContextPrompt(forms) {
    const live = liveMcaForms(forms);
    const fdmca = live.find(formIsFdmca);
    const bid = live.find(formIsBid);
    if (fdmca &&
        !bid &&
        formIsCompleted(fdmca) &&
        fdmcaFoundLackOfCapacity(fdmca))
        return { templateId: BID_TEMPLATE_ID };
    if (bid && !fdmca && formIsCompleted(bid))
        return { templateId: FDMCA_TEMPLATE_ID };
    return null;
}
//# sourceMappingURL=mca.js.map